const trans = {
    en: {
        "Obtenez un prix en quelques clics": "Get a quote in just a few clicks",
        "Sélectionner un autre produit": 'Choose another product',
        "Largeur": 'Width',
        "Longueur": 'Length',
        "Hauteur": 'Height',
        "Calculer": 'Calculate',
        "Retour": 'Back',
        "Points de vente": 'Sales Points',
        "Nous joindre": 'Contact us',
        "La différence TEMPO": 'The TEMPO difference',
        "Abris Tempo est le pionnier dans la conception et la fabrication d'abris d'auto au Québec.": 'Tempo shelter is the pioneer in the design and manufacture of car shelter in Quebec.',
        "Voir la vidéo": 'See the video',
        "Toile seulement": 'Cover only',
        "*Les prix sont sujet à changement sans préavis.": '*Prices subject to change without notice.',
    },
    fr: {}
}

export default trans
